__turbopack_context__.v({
  "typographyWrapper": "JzJ-Eq_typographyWrapper",
});
